import { ThemeUIStyleObject } from 'theme-ui';

import * as dto from 'client/dto';
import { locationTypePrint } from 'utils/stringFormattingHelpers';

import { GeonameCategory, LocationSearchResult, LocationSearchType, LocationType } from './models';

export const MinLocationSearchLength = 3;

export const searchMenuWrapperStyles = (mobileDropdownShadow = false): ThemeUIStyleObject => ({
  boxShadow: mobileDropdownShadow
    ? '0px 4px 4px rgba(0, 0, 0, 0.15)'
    : [null, '0px 4px 4px rgba(0, 0, 0, 0.15)'],
  borderRadius: '4px',
  width: '100%',
  borderRightColor: '@stone20',
  bg: 'seafoam10',
  position: [null, 'absolute'],
  zIndex: ['initial', 100],
  overflowY: 'auto',
  maxHeight: `calc(50vh - 42px)`, // Half the viewport - half height of the input - 24px for space in the bottom
});

export const mapResultToGeonameOptions = (
  locations: LocationSearchResult[],
  type: LocationType,
  selectedIds: number[]
) =>
  locations
    ? locations
        .filter(l => l.locationType === type)
        .map(searchRes => ({
          id: searchRes.id,
          name: searchRes.displayName,
          disabled: (selectedIds || []).some(id => id === searchRes.id),
          data: searchRes,
        }))
    : [];

export const mapResultToAdditiveCategories = (
  data: LocationSearchResult[],
  selectedIds: number[]
) => {
  const catCountries: GeonameCategory = {
    name: locationTypePrint(dto.LocationType.Country),
    values: mapResultToGeonameOptions(data, dto.LocationType.Country, selectedIds),
  };
  const catProvinces: GeonameCategory = {
    name: locationTypePrint(dto.LocationType.Province),
    values: mapResultToGeonameOptions(data, dto.LocationType.Province, selectedIds),
  };
  const catMetroAreas: GeonameCategory = {
    name: locationTypePrint(dto.LocationType.MetroArea),
    values: mapResultToGeonameOptions(data, dto.LocationType.MetroArea, selectedIds),
  };
  const catCounties: GeonameCategory = {
    name: locationTypePrint(dto.LocationType.County),
    values: mapResultToGeonameOptions(data, dto.LocationType.County, selectedIds),
  };
  const catCities: GeonameCategory = {
    name: locationTypePrint(dto.LocationType.City),
    values: mapResultToGeonameOptions(data, dto.LocationType.City, selectedIds),
  };
  const catAirports: GeonameCategory = {
    name: locationTypePrint(LocationSearchType.Airport),
    values: mapResultToGeonameOptions(data, LocationSearchType.Airport, selectedIds),
  };

  return [
    ...(catCountries.values.length ? [catCountries] : []),
    ...(catProvinces.values.length ? [catProvinces] : []),
    ...(catMetroAreas.values.length ? [catMetroAreas] : []),
    ...(catCounties.values.length ? [catCounties] : []),
    ...(catCities.values.length ? [catCities] : []),
    ...(catAirports.values.length ? [catAirports] : []),
  ];
};
